import axios from 'axios';
// 组织列表
export const orgList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/organization/sysOragnize.ajax?cmd=loadOragnizeMenuData',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 组织员工列表
export const orgUserList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/organization/staffBO.ajax?cmd=queryStaffByOrgId',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 组织员工修改
export const orgUserAdd = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/organization/sysOragnize.ajax?cmd=addStaffsToOrg',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 组织员工删除
export const orgUserDel = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/organization/sysOragnize.ajax?cmd=delRelationStaffAndOrg',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 组织删除
export const orgDel = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/organization/sysOragnize.ajax?cmd=delOragnize',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 组织详情
export const orgDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/organization/sysOragnize.ajax?cmd=getOragnizeByOrgId',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 组织修改
export const orgEdit = async (data) => new Promise((resolve, reject) => {
  let url = '/organization/sysOragnize.ajax?cmd=doSave';
  if (data.orgId) {
    url = 'organization/sysOragnize.ajax?cmd=doUpdateOrg';
  }
  axios({
    url,
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 用户列表
export const userList = async (data) => new Promise((resolve, reject) => {
  axios({
    // url: '/staffBO.ajax?cmd=queryStaffListByRoleId',
    url: '/staffBO.ajax?cmd=queryStaff',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 用户设置角色
export const userSetRole = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/staffBO.ajax?cmd=doAccreditStaff',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 用户删除
export const userDel = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/staffBO.ajax?cmd=doDelStaff',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 用户详情
export const userDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/staffBO.ajax?cmd=getStaff',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 用户修改
export const userEdit = async (data) => new Promise((resolve, reject) => {
  let url = '/staffBO.ajax?cmd=doSave';
  if (data.userId) {
    url = '/staff/staffBO.ajax?cmd=doUpdate';
  }
  axios({
    url,
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 移除授权
export const delRelationRoleAndUser = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sysRoleBO.ajax?cmd=delRelationRoleAndUser',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 角色列表
export const roleList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sysRoleBO.ajax?cmd=queryRole',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 角色人员列表
export const roleUserList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/staffBO.ajax?cmd=queryStaffListByEntityId',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 角色删除
export const roleDel = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sysRoleBO.ajax?cmd=delRole',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 角色详情
export const roleDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sysRoleBO.ajax?cmd=getRole',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 角色修改
export const roleEdit = async (data) => new Promise((resolve, reject) => {
  let url = '/sysRoleBO.ajax?cmd=doSave';
  if (data.roleId) {
    url = '/sysRoleBO.ajax?cmd=doUpdate';
  }
  axios({
    url,
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 偷懒做法：将按钮级别的菜单拼在 菜单级别菜单 的 childMenus 里面
const handleMenuData = (list) => {
  for (let i = 0; i < list.length; i++) {
    if (list[i].funcNameAlias) {
      list[i].menuName = list[i].funcNameAlias;
    }
    if (list[i].funcList && list[i].funcList.length && list[i].isLeaf) {
      list[i].childMenus = list[i].funcList;
      // 全选判断
      let currentNode$$isChecked = true;
      for (let j = 0; j < list[i].funcList.length; j++) {
        if (!list[i].funcList[j].$$isChecked) {
          currentNode$$isChecked = false;
          break;
        }
      }
      list[i].$$isChecked = currentNode$$isChecked;

      handleMenuData(list[i].childMenus);
    } else if (list[i].childMenus) {
      handleMenuData(list[i].childMenus);
    }
  }
};
export const jurisdictionList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sysRoleBO.ajax?cmd=getSelectMenuByRoleId',
    method: 'post',
    data,
  }).then(async (res) => {
    handleMenuData(res.sysMenu1.childMenus);
    handleMenuData(res.sysMenu2.childMenus);
    handleMenuData(res.sysMenu3.childMenus);
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 审核人列表
export const auditUserList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/auditSettingBO.ajax?cmd=querStaffDataInfos',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 基础审核列表
export const baseApproveList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/auditSettingBO.ajax?cmd=queryBaseDataAudit',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 基础资料审核人修改
export const baseApproveEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/auditSettingBO.ajax?cmd=saveNodeAuditStaff',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 基础资料审核人清除
export const baseApproveRemove = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/auditSettingBO.ajax?cmd=removeNode',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 业务流程审核列表
export const businessApproveList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/auditSettingBO.ajax?cmd=queryBusiDataAudit',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 业务资料规则
export const businessApproveRule = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/auditSettingBO.ajax?cmd=getAuditRule',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 业务资料规则 - 修改
export const businessApproveRuleEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/auditSettingBO.ajax?cmd=saveAuditRule',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 导入列表
export const importList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sys/sysImportBO.ajax?cmd=queryImportResult',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 下载导入原文件
export const downloadImportOriginFile = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/attach.ajax?cmd=doQuery',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 下载导入失败原因
export const downloadImportReason = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sys/sysImportBO.ajax?cmd=getSysImportItemConfigByResultId',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 下载导入失败文件
export const downloadFailFail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sys/sysImportBO.ajax?cmd=downloadFailFile',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 导出列表
export const exportList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sysImportBO.ajax?cmd=queryExportResult',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 员工列表
export const workerList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceProductOilsBO.ajax?cmd=queryStaffInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 资金风控数据
export const riskCapital = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payFeeLimitBO.ajax?cmd=queryPayFeeLimitCfg',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 资金风控审核数据
export const riskCapitalApproveData = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payFeeLimitBO.ajax?cmd=queryPayFeeLimitCfgUpdt',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 资金风控修改
export const riskCapitalEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payFeeLimitBO.ajax?cmd=saveOrUpdate',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 司机权益
export const driverBenefits = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/userCreditBO.ajax?cmd=queryMemberBenefits',
    method: 'post',
    data,
  }).then(async (res) => {
    const premiumRes = await driverBenefitsPremium({
      ruleId: res.items[0].ruleId,
    });
    const freightRes = await driverBenefitsFreight({
      codeType: 'TRANSPORT_COST_SECTION',
      state: 1,
    });
    resolve({
      freight: freightRes.items,
      premium: premiumRes.items,
      ...res.items[0],
    });
  }).catch((err) => {
    reject(err);
  });
});

// 司机权益 - 运费
export const driverBenefitsFreight = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/staticDataBO.ajax?cmd=getSysStaticDataByCodeType',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 司机权益 - 保费
export const driverBenefitsPremium = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/userCreditBO.ajax?cmd=queryCreditRatingRuleFees',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 司机权益 - 修改
export const driverBenefitsEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/userCreditBO.ajax?cmd=saveOrUpdate',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 订单风控 - 修改
export const orderLimitCfgEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/orderLimitCfgBO.ajax?cmd=saveOrUpdate',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 订单风控 - 查询
export const orderLimitCfg = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/orderLimitCfgBO.ajax?cmd=getOrderLimtCfg',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 订单风控 - 查询值
export const orderLimitCfgValue = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/orderLimitCfgBO.ajax?cmd=getOrderLimtCfgValueByNameCode',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 理赔录入列表
export const claimsList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=queryClaimEntry',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 理赔录入修改
export const claimsEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=queryVehicleAccidentInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 理赔录入修改
export const claimsDialogList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=queryClaimEntry',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});


// 批量审核记录列表
export const queryDealDataRecord = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sysOperLogBO.ajax?cmd=queryDealDataRecord',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 确认批量审核通过数据
export const executeDealData = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sysOperLogBO.ajax?cmd=executeDealData',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
